import { FC, MouseEvent } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Menu, Dropdown, Avatar, Button } from 'antd'
import { DownOutlined } from '@ant-design/icons'

import PremiumTag from '~/apps/consumer/pages/Quotes/Builder/QuoteDetailPage/PremiumTag/index'
import Link from '~/core/Link'
import Text from '~/core/Text'
import Box from '~/core/Box'
import { getUserIdentity, signOutUser } from '~/redux-modules/identity'
import OnBoardLink from '../OnBoardLink'
import getColor from '~/lib/getColor'
import icons from '~/apps/consumer/icons'
import Image from '~/core/Image'

import styles from './styles.css'

const PLACEMENT = 'top_nav'

interface UserAccountDropDownProps {
    openModal: Function
}

export const UserAccountDropDown: FC<UserAccountDropDownProps> = ({
    openModal,
}) => {
    const dispatch = useDispatch()
    const { firstName, email, businessAccountMembership } =
        useSelector(getUserIdentity)
    const firstLetter = (firstName?.[0] || email[0]).toUpperCase()
    const signOut = (event: MouseEvent<HTMLElement>) => {
        event.preventDefault()
        dispatch(signOutUser())
    }
    const isTeamsFeatureOn =
        !!businessAccountMembership?.businessAccount?.isTeamsFeatureEnabled

    const menu = (
        <Menu className={styles.menu}>
            <Menu.Item>
                <Link
                    to={'/pages/my-account'}
                    placement={PLACEMENT}
                    name="account"
                >
                    My Account
                    {isTeamsFeatureOn ? (
                        <span
                            style={{
                                color: getColor('premiumBrandingTxt'),
                                fontSize: '14px',
                                fontWeight: 400,
                                float: 'right',
                            }}
                        >
                            <Image
                                style={{ height: '14px', width: '14px' }}
                                src={icons.premiumTagImg}
                            />
                        </span>
                    ) : (
                        ''
                    )}
                </Link>
            </Menu.Item>
            <Menu.Item>
                <OnBoardLink />
            </Menu.Item>
            <Menu.Item>
                <Link onClick={signOut} name="Log out" placement={PLACEMENT}>
                    Log out
                    <Text className={styles.truncatedEmail}>{email}</Text>
                </Link>
            </Menu.Item>
        </Menu>
    )

    const userInfo = (
        <>
            {businessAccountMembership?.businessAccount?.name && (
                <Text
                    style={{
                        marginRight: '20px',
                    }}
                >
                    {businessAccountMembership?.businessAccount?.name}
                </Text>
            )}
            <Avatar size={20} className={styles.avatar}>
                {firstLetter}
            </Avatar>
            <DownOutlined
                style={{
                    margin: '1px 0 0 10px',
                    fontSize: '10px',
                }}
            />
        </>
    )

    return (
        <Box style={{ marginRight: '16px' }}>
            {isTeamsFeatureOn ? (
                <Dropdown.Button
                    overlay={menu}
                    icon={
                        <div className={styles.businessAccountMenuButton}>
                            {userInfo}
                        </div>
                    }
                    onClick={() => {
                        openModal('UPSELL')
                    }}
                    className={styles.premiumTagButton}
                >
                    <span
                        key="premiumTag"
                        data-test-target="user-account-premium-tag"
                    >
                        <PremiumTag type="premium" />
                    </span>
                </Dropdown.Button>
            ) : (
                <Dropdown overlay={menu}>
                    <Button style={{ display: 'flex', alignItems: 'center' }}>
                        {userInfo}
                    </Button>
                </Dropdown>
            )}
        </Box>
    )
}
